<template>
<div class="chapter">
<div class="inner_page">
<p class="deda"><a id="ded1"></a><a id="page_xiii">“Nothing fixes a thing so intensely in the memory as the wish to forget it.”</a></p><a id="page_xiii">
<p class="rightq">—Michel de Montaigne, February 28,1533–September 13, 1592</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded1.vue?73b79ed4